import views from './Views'
import macros from './Macros'
import actions from './Actions'
import relations from './Relations'
import types from './Types'
import attributes from './Attributes'
import tasks from './Tasks'

accumulated = {
  actions...,
  attributes...,
  relations...,
  types...,
  views...,
  macros...,
  tasks...
}

# props: {
#   setCurrentItem
#   setOpenInConsole
#   setTabDisabled
#   setTableConfig
#   params
#   history
#}

export default onSelect = (node, props) ->
  accumulated[node.type]?(node, props)
